import { Component, inject } from "@angular/core";
import { derivedAsync } from "ngxtension/derived-async";
import { Skeleton } from "primeng/skeleton";
import { catchError, of } from "rxjs";
import { AppDatePipe } from "../../../shared/pipes/date.pipe";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiDashboardCardHeaderComponent } from "../layout/new-ui-dashboard-card-header/new-ui-dashboard-card-header.component";
import { NewUiDashboardCardComponent } from "../layout/new-ui-dashboard-card/new-ui-dashboard-card.component";
import { NewUiDashboardService } from "../new-ui-dashboard.service";

@Component({
  selector: "new-ui-dashboard-release-notes-notes",
  templateUrl: "./new-ui-dashboard-release-notes.component.html",
  imports: [NewUiDashboardCardHeaderComponent, NewUiDashboardCardComponent, TranslateDirective, AppDatePipe, Skeleton],
})
export class NewUiDashboardReleaseNotesComponent {
  private readonly dashboardService = inject(NewUiDashboardService);

  protected readonly ankaadiaUpdate = derivedAsync(() =>
    this.dashboardService.getAnkaadiaUpdate().pipe(catchError(() => of(null)))
  );
}
